// extracted by mini-css-extract-plugin
export default {"wrap":"KJ-z","articleImagesWrap":"LJ-z","articleImage":"MJ-z","singleImage":"NJ-z"};